module.exports = __webpack_public_path__ + "static/media/DQFrameworkWheel_2023_FINAL-1536x1424.5b50608c.png";